const ITEMS = [
  "Architectural Glass",
  "Aluminium Systems",
  "Shower Enclosures",
  "Glass Partitions",
  "LED Mirrors",
  "Glass Railings",
  "Storefronts",
  "Toughened Glass",
];

// Slow editorial marquee
const Marquee = () => (
  <section className="marquee-wrap overflow-hidden border-y border-black/10 bg-cream/60 py-6 md:py-8" data-testid="marquee">
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="px-10 font-display text-2xl italic tracking-tight text-ink/85 md:text-4xl">
                {item}
              </span>
              <span className="text-gold">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
